import { useMutation } from '@tanstack/react-query';
import { setCardShipmentAddress } from '@Services/api/cardShipment.api';
import type { MutationOnSuccess } from '@Types/util';

type SetCardShipmentAddressOnSuccess = MutationOnSuccess<typeof setCardShipmentAddress>;

export const useSetCardShipmentAddress = (onSuccess: SetCardShipmentAddressOnSuccess) =>
  useMutation({
    mutationFn: setCardShipmentAddress,
    mutationKey: ['setCardShipmentAddress'],
    onSuccess,
  });
